import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { MapSection } from '../../shared/components/MapSection';
import { useLang } from '../../../i18n/LanguageContext';
import { topDict } from '../../../i18n/dictionaries/top';
import styles from './TopPage.module.css';
import aboutImage from '../../../assets/top/about.png';
import ceoImage from '../../../assets/top/ceo.png';

export const TopPage = (): JSX.Element => {
  const { lang } = useLang();
  const t = topDict[lang];

  return (
    <div className={styles.page}>
      <SiteHeader variant="overlay" />

      <section className={styles.hero}>
        <p className={styles.heroEyebrow}>INVEST BEYOND BORDERS.</p>
        <h1 className={styles.heroTitle}>
          {t.heroTitle.map((line, index) => (
            <span key={line}>
              {index > 0 && <br />}
              {line}
            </span>
          ))}
        </h1>
        <p className={styles.heroLead}>
          {t.heroLead.map((line, index) => (
            <span key={line}>
              {index > 0 && <br />}
              {line}
            </span>
          ))}
        </p>
        <div className={styles.scroll}>
          <span className={styles.scrollLine} aria-hidden />
          <span className={styles.scrollText}>SCROLL</span>
        </div>
      </section>

      <section className={styles.about}>
        <img
          className={styles.aboutImage}
          src={aboutImage}
          alt="C.J INVESTMENT CO.,LTD オフィスサイン"
        />
        <div className={styles.aboutText}>
          {t.about.map((paragraph) => (
            <p key={paragraph.slice(0, 12)}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section id="service" className={styles.service}>
        <div className={styles.serviceInner}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>SERVICE</p>
            <h2 className={styles.sectionTitle}>{t.serviceTitle}</h2>
          </div>
          <div className={styles.serviceGrid}>
            {t.services.map((service) => (
              <div key={service.title} className={styles.serviceItem}>
                <h3 className={styles.serviceItemTitle}>{service.title}</h3>
                <div className={styles.serviceItemBody}>
                  {service.body.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.serviceActions}>
            <a href="/services" className={styles.button}>
              {t.serviceButton}
            </a>
          </div>
        </div>
      </section>

      <section className={styles.why}>
        <div className={styles.whyInner}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>WHY CJ INVESTMENT</p>
            <h2 className={styles.sectionTitle}>{t.whyTitle}</h2>
          </div>
          <div className={styles.whyGrid}>
            {t.whyItems.map((item) => (
              <div key={item.number} className={styles.whyItem}>
                <p>
                  <span className={styles.whyNumber}>{item.number}</span>
                  {item.heading}
                </p>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="message" className={styles.message}>
        <img
          className={styles.messageImage}
          src={ceoImage}
          alt={`${t.signRole} ${t.signName}`}
        />
        <div className={styles.messageBody}>
          <p className={styles.eyebrow}>MESSAGE</p>
          <h2 className={styles.messageTitle}>{t.messageTitle}</h2>
          <p className={styles.messageText}>
            {t.messageText.map((paragraph, index) => (
              <span key={paragraph.slice(0, 12)}>
                {index > 0 && (
                  <>
                    <br />
                    <br />
                  </>
                )}
                {paragraph}
              </span>
            ))}
          </p>
          <div className={styles.messageSign}>
            <p className={styles.messageSignRole}>{t.signRole}</p>
            <p className={styles.messageSignName}>{t.signName}</p>
          </div>
          <a href="/about" className={styles.button}>
            {t.messageButton}
          </a>
        </div>
      </section>

      <MapSection />

      <SiteFooter />
    </div>
  );
};
